// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__35M06","description":"PatientConsentPreview_description__1_buK"};